import "core-js/modules/es6.reflect.construct.js";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.find.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import classNames from 'classnames';
import List from './list';
import Operation from './operation';
import Search from './search';
import PropTypes from 'prop-types';
import { DragDropContext } from 'react-beautiful-dnd';
import { reorder, move } from './utils';
import { WebUI } from "../../wui-core/src/index.js";

function noop() {}

var defaultProps = {
  dataSource: [],
  render: noop,
  showSearch: false,
  searchPlaceholder: 'Search',
  notFoundContent: 'Not Found',
  showCheckbox: true,
  draggable: false,
  appendToBottom: false,
  renderOperation: function renderOperation() {
    return '';
  } //自定义操作

};
var propTypes = {
  prefixCls: PropTypes.string,
  dataSource: PropTypes.array,
  render: PropTypes.func,
  targetKeys: PropTypes.array,
  onChange: PropTypes.func,
  height: PropTypes.number,
  listStyle: PropTypes.object,
  className: PropTypes.string,
  titles: PropTypes.array,
  operations: PropTypes.array,
  showSearch: PropTypes.bool,
  filterOption: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  notFoundContent: PropTypes.node,
  body: PropTypes.func,
  footer: PropTypes.func,
  rowKey: PropTypes.func,
  lazy: PropTypes.object,
  showCheckbox: PropTypes.bool,
  draggable: PropTypes.bool,
  appendToBottom: PropTypes.bool,
  renderOperation: PropTypes.func
};
var defaultTitles = ['', ''];
var Transfer = (_dec = WebUI({
  name: "transfer",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(Transfer, _React$Component);

  var _super = _createSuper(Transfer);

  function Transfer(props) {
    var _this;

    _classCallCheck(this, Transfer);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "addUniqueKey", function (dataSource) {
      var rowKey = _this.props.rowKey;

      if (rowKey) {
        dataSource.forEach(function (record) {
          record.key = rowKey(record);
        });
      }

      return dataSource;
    });

    _defineProperty(_assertThisInitialized(_this), "moveTo", function (direction, insertIndex) {
      var _this$props = _this.props,
          _this$props$targetKey = _this$props.targetKeys,
          targetKeys = _this$props$targetKey === void 0 ? [] : _this$props$targetKey,
          onChange = _this$props.onChange,
          appendToBottom = _this$props.appendToBottom;
      var _this$state = _this.state,
          sourceSelectedKeys = _this$state.sourceSelectedKeys,
          targetSelectedKeys = _this$state.targetSelectedKeys,
          leftDataSource = _this$state.leftDataSource,
          rightDataSource = _this$state.rightDataSource,
          droppableId = _this$state.droppableId;
      var moveKeys = direction === 'right' ? sourceSelectedKeys : targetSelectedKeys; // let temp = appendToBottom ? targetKeys.concat(moveKeys) : moveKeys.concat(targetKeys); // 在这里

      var temp = [];

      if (appendToBottom) {
        temp = targetKeys.concat(moveKeys);
      } else if (insertIndex) {
        targetKeys.splice.apply(targetKeys, [insertIndex, 0].concat(_toConsumableArray(moveKeys)));
        temp = targetKeys;
      } else {
        temp = moveKeys.concat(targetKeys);
      } // move items to target box


      var newTargetKeys = direction === 'right' ? temp : targetKeys.filter(function (targetKey) {
        return moveKeys.indexOf(targetKey) === -1;
      }); // empty checked keys

      var oppositeDirection = direction === 'right' ? 'left' : 'right';

      _this.setState(_defineProperty({}, _this.getSelectedKeysName(oppositeDirection), []));

      _this.handleSelectChange(oppositeDirection, []);

      if (onChange) {
        onChange(newTargetKeys, direction, moveKeys);
      } // 区分拖拽穿梭还是点击穿梭


      var newDataSource = leftDataSource.concat(rightDataSource);
      droppableId ? _this.splitDataSource2(newTargetKeys, newDataSource) : _this.splitDataSource(newTargetKeys);
    });

    _defineProperty(_assertThisInitialized(_this), "moveToLeft", function () {
      return _this.moveTo('left');
    });

    _defineProperty(_assertThisInitialized(_this), "moveToRight", function (insertIndex) {
      return _this.moveTo('right', insertIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectAll", function (direction, filteredDataSource, checkAll) {
      var holder = checkAll ? [] : filteredDataSource.map(function (item) {
        return item.key;
      });

      _this.handleSelectChange(direction, holder);

      if (!_this.props.selectedKeys) {
        _this.setState(_defineProperty({}, _this.getSelectedKeysName(direction), holder));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleLeftSelectAll", function (filteredDataSource, checkAll) {
      _this.handleSelectAll('left', filteredDataSource, checkAll);
    });

    _defineProperty(_assertThisInitialized(_this), "handleRightSelectAll", function (filteredDataSource, checkAll) {
      return _this.handleSelectAll('right', filteredDataSource, checkAll);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFilter", function (direction, value) {
      _this.setState(_defineProperty({}, "".concat(direction, "Filter"), value));
    });

    _defineProperty(_assertThisInitialized(_this), "handleLeftFilter", function (v) {
      return _this.handleFilter('left', v);
    });

    _defineProperty(_assertThisInitialized(_this), "handleRightFilter", function (v) {
      return _this.handleFilter('right', v);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClear", function (direction) {
      _this.setState(_defineProperty({}, "".concat(direction, "Filter"), ''));
    });

    _defineProperty(_assertThisInitialized(_this), "handleLeftClear", function () {
      return _this.handleClear('left');
    });

    _defineProperty(_assertThisInitialized(_this), "handleRightClear", function () {
      return _this.handleClear('right');
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelect", function (direction, selectedItem, checked) {
      var _this$state2 = _this.state,
          sourceSelectedKeys = _this$state2.sourceSelectedKeys,
          targetSelectedKeys = _this$state2.targetSelectedKeys;
      var holder = direction === 'left' ? _toConsumableArray(sourceSelectedKeys) : _toConsumableArray(targetSelectedKeys);
      var index = holder.indexOf(selectedItem.key);

      if (checked) {
        //已勾选
        holder.splice(index, 1);
      } else if (index === -1) {
        //未勾选
        holder.push(selectedItem.key);
      }

      _this.handleSelectChange(direction, holder);

      if (!_this.props.selectedKeys) {
        _this.setState(_defineProperty({}, _this.getSelectedKeysName(direction), holder));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleLeftSelect", function (selectedItem, checked) {
      return _this.handleSelect('left', selectedItem, checked);
    });

    _defineProperty(_assertThisInitialized(_this), "handleRightSelect", function (selectedItem, checked) {
      return _this.handleSelect('right', selectedItem, checked);
    });

    _defineProperty(_assertThisInitialized(_this), "getTitles", function () {
      if (_this.props.titles) {
        return _this.props.titles;
      }

      if (_this.context && _this.context.antLocale && _this.context.antLocale.Transfer) {
        return _this.context.antLocale.Transfer.titles || [];
      }

      return defaultTitles;
    });

    _defineProperty(_assertThisInitialized(_this), "id2List", {
      droppable_1: 'leftDataSource',
      droppable_2: 'rightDataSource'
    });

    _defineProperty(_assertThisInitialized(_this), "getList", function (id) {
      return _this.state[_this.id2List[id]];
    });

    _defineProperty(_assertThisInitialized(_this), "onDragEnd", function (result) {
      _this.setState({
        draggingItemId: ''
      });

      var source = result.source,
          destination = result.destination,
          draggableId = result.draggableId;
      var _this$props2 = _this.props,
          targetKeys = _this$props2.targetKeys,
          onChange = _this$props2.onChange;
      var sourceIndex = source ? source.index : ''; //初始位置

      var disIndex = destination ? destination.index : ''; //移动后的位置

      var temp; //拖拽的元素
      // case1：拖拽到列表之外

      if (!destination) {
        return;
      }

      if (destination.droppableId === 'droppable_1') {
        // case2：在左侧列表中拖拽
        if (source.droppableId === destination.droppableId) return; // case3：从右往左拖拽（移除已选）

        _this.moveToLeft();

        return;
      } // case4：在右侧列表中拖拽改变items顺序


      if (source.droppableId === destination.droppableId) {
        var items = reorder(_this.getList(source.droppableId), targetKeys, sourceIndex, disIndex);

        _this.setState({
          rightDataSource: items.dataArr,
          sourceSelectedKeys: [],
          targetSelectedKeys: []
        });

        if (onChange) {
          onChange(items.targetKeyArr, "", draggableId);
        }
      } else {
        // case5：从左往右拖拽（添加已选）
        if (_this.state.sourceSelectedKeys.length > 1) {
          return _this.moveToRight(destination.index);
        }

        var _result = move( // 一次移动的方法
        _this.getList(source.droppableId), _this.getList(destination.droppableId), source, destination, targetKeys);

        if (onChange) {
          // onChange事件
          onChange(_result.newTargetKeys, "", draggableId);
        }

        _this.setState({
          leftDataSource: _result.droppable_1,
          rightDataSource: _result.droppable_2,
          sourceSelectedKeys: [],
          targetSelectedKeys: []
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDragStart", function (result) {
      var selectedItem = {};
      var source = result.source;
      selectedItem.key = result.draggableId;

      if (source.droppableId === 'droppable_1') {
        // leftMenu
        _this.handleLeftSelect(selectedItem);
      } else if (source.droppableId === 'droppable_2') {
        // rightMenu
        _this.handleRightSelect(selectedItem);
      }

      _this.setState({
        droppableId: source.droppableId,
        draggingItemId: result.draggableId
      });
    });

    var _props$selectedKeys = props.selectedKeys,
        selectedKeys = _props$selectedKeys === void 0 ? [] : _props$selectedKeys,
        _props$targetKeys = props.targetKeys,
        _targetKeys = _props$targetKeys === void 0 ? [] : _props$targetKeys;

    _this.state = {
      leftFilter: '',
      rightFilter: '',
      sourceSelectedKeys: selectedKeys.filter(function (key) {
        return _targetKeys.indexOf(key) === -1;
      }),
      targetSelectedKeys: selectedKeys.filter(function (key) {
        return _targetKeys.indexOf(key) > -1;
      }),
      leftDataSource: [],
      rightDataSource: [],
      droppableId: '',
      draggingItemId: ''
    };
    _this.cacheTargetKeys = _toConsumableArray(_targetKeys);
    return _this;
  }

  _createClass(Transfer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.splitDataSource();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$state3 = this.state,
          sourceSelectedKeys = _this$state3.sourceSelectedKeys,
          targetSelectedKeys = _this$state3.targetSelectedKeys;

      if (nextProps.targetKeys !== this.props.targetKeys || nextProps.dataSource !== this.props.dataSource || nextProps.targetKeys !== this.cacheTargetKeys) {
        // clear cached splited dataSource
        this.splitedDataSource = null;
        var dataSource = nextProps.dataSource,
            _nextProps$targetKeys = nextProps.targetKeys,
            targetKeys = _nextProps$targetKeys === void 0 ? [] : _nextProps$targetKeys;

        function existInDateSourcekey(key) {
          return dataSource.filter(function (item) {
            return item.key === key;
          }).length;
        } // clear key nolonger existed
        // clear checkedKeys according to targetKeys


        this.setState({
          sourceSelectedKeys: sourceSelectedKeys.filter(existInDateSourcekey).filter(function (data) {
            return targetKeys.filter(function (key) {
              return key === data;
            }).length === 0;
          }),
          targetSelectedKeys: targetSelectedKeys.filter(existInDateSourcekey).filter(function (data) {
            return targetKeys.filter(function (key) {
              return key === data;
            }).length > 0;
          })
        }); //异步加载时 || 动态改变targetKeys时

        if (this.props.dataSource.length === 0 || !this.props.draggable) {
          this.splitDataSource(targetKeys, dataSource);
        }
      }

      if (nextProps.selectedKeys) {
        var _targetKeys2 = nextProps.targetKeys;
        this.setState({
          sourceSelectedKeys: nextProps.selectedKeys.filter(function (key) {
            return _targetKeys2.indexOf(key) === -1;
          }),
          targetSelectedKeys: nextProps.selectedKeys.filter(function (key) {
            return _targetKeys2.indexOf(key) > -1;
          })
        });
      }
    }
    /**
     * 给dataSource里的数据值指定唯一 key 值
     */

  }, {
    key: "splitDataSource",
    value:
    /**
     * 从源dataSource中分离出leftDataSource和rightDataSource（点击按钮穿梭时调用）
     * @param {*} newTargetKeys 更新后的targetKeys
     * @param {*} newDataSource 异步加载数据源时，从nextProps中获取的dataSource
     */
    function splitDataSource(newTargetKeys, newDataSource) {
      var _this2 = this;

      // targetKeys：展示在右边列表的数据集
      if (this.splitedDataSource) {
        return this.splitedDataSource;
      }

      var targetKeys = newTargetKeys || this.props.targetKeys; //异步加载数据源时/移除已选时

      var dataSource = newDataSource || this.props.dataSource;
      dataSource = this.addUniqueKey(dataSource);
      this.allSourceKeys = dataSource.map(function (_ref) {
        var key = _ref.key;
        return key;
      });
      var leftDataSource = dataSource.filter(function (_ref2) {
        var key = _ref2.key;
        return targetKeys.indexOf(key) === -1;
      }); // const rightDataSource = dataSource.filter(({key}) => targetKeys.indexOf(key) > -1);
      // 右侧数据源根据传入的targetKeys进行排序

      var rightDataSource = [];
      var tempIndex = -1;
      targetKeys.forEach(function (key) {
        tempIndex = _this2.allSourceKeys.indexOf(key);
        rightDataSource.push(dataSource[tempIndex]);
      });
      this.splitedDataSource = {
        leftDataSource: leftDataSource,
        rightDataSource: rightDataSource
      };
      this.setState({
        leftDataSource: leftDataSource,
        rightDataSource: rightDataSource
      });
      return this.splitedDataSource;
    }
    /**
     * 从自定义顺序的dataSource中分离出leftDataSource和rightDataSource（拖拽场景调用）
     * @param {*} newTargetKeys 更新后的targetKeys
     * @param {*} newDataSource 通过 leftDataSource.concat(rightDataSource) 得到的newDataSource
     */

  }, {
    key: "splitDataSource2",
    value: function splitDataSource2(newTargetKeys, newDataSource) {
      // targetKeys：展示在右边列表的数据集
      if (this.splitedDataSource) {
        return this.splitedDataSource;
      }

      var targetKeys = newTargetKeys || this.props.targetKeys; //异步加载数据源时/移除已选时

      var sourceDataSource = this.props.dataSource;
      newDataSource = this.addUniqueKey(newDataSource);
      sourceDataSource = this.addUniqueKey(sourceDataSource);
      var leftDataSource = sourceDataSource.filter(function (_ref3) {
        var key = _ref3.key;
        return targetKeys.indexOf(key) === -1;
      });
      var rightDataSource = targetKeys.map(function (key) {
        return newDataSource.find(function (data) {
          return data.key === key;
        });
      });
      this.splitedDataSource = {
        leftDataSource: leftDataSource,
        rightDataSource: rightDataSource
      };
      this.setState({
        leftDataSource: leftDataSource,
        rightDataSource: rightDataSource
      });
      return this.splitedDataSource;
    }
  }, {
    key: "handleSelectChange",
    value:
    /**
     * List中的item选中/未选中状态改变时触发
     * @param {*} direction 'left' or 'right'
     * @param {*} holder 更新后的'sourceSelectedKeys' or 'targetSelectedKeys'
     */
    function handleSelectChange(direction, holder) {
      // onSelectChange：当选中的item发生改变时的回调 参数(sourceSelectedKeys, targetSelectedKeys)
      var _this$state4 = this.state,
          sourceSelectedKeys = _this$state4.sourceSelectedKeys,
          targetSelectedKeys = _this$state4.targetSelectedKeys;
      var onSelectChange = this.props.onSelectChange;

      if (!onSelectChange) {
        return;
      }

      if (direction === 'left') {
        onSelectChange(holder, targetSelectedKeys);
      } else {
        onSelectChange(sourceSelectedKeys, holder);
      }
    }
  }, {
    key: "getSelectedKeysName",
    value: function getSelectedKeysName(direction) {
      return direction === 'left' ? 'sourceSelectedKeys' : 'targetSelectedKeys';
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          clsPrefix = _this$props3.clsPrefix,
          _this$props3$operatio = _this$props3.operations,
          operations = _this$props3$operatio === void 0 ? [] : _this$props3$operatio,
          showSearch = _this$props3.showSearch,
          notFoundContent = _this$props3.notFoundContent,
          searchPlaceholder = _this$props3.searchPlaceholder,
          body = _this$props3.body,
          footer = _this$props3.footer,
          listStyle = _this$props3.listStyle,
          _this$props3$classNam = _this$props3.className,
          className = _this$props3$classNam === void 0 ? '' : _this$props3$classNam,
          filterOption = _this$props3.filterOption,
          render = _this$props3.render,
          lazy = _this$props3.lazy,
          showCheckbox = _this$props3.showCheckbox,
          draggable = _this$props3.draggable,
          renderOperation = _this$props3.renderOperation;
      var _this$state5 = this.state,
          leftFilter = _this$state5.leftFilter,
          rightFilter = _this$state5.rightFilter,
          sourceSelectedKeys = _this$state5.sourceSelectedKeys,
          targetSelectedKeys = _this$state5.targetSelectedKeys,
          leftDataSource = _this$state5.leftDataSource,
          rightDataSource = _this$state5.rightDataSource,
          droppableId = _this$state5.droppableId,
          draggingItemId = _this$state5.draggingItemId; // const { leftDataSource, rightDataSource } = this.splitDataSource(this.props);

      var leftActive = targetSelectedKeys.length > 0;
      var rightActive = sourceSelectedKeys.length > 0;
      var cls = classNames(className, clsPrefix);
      var titles = this.getTitles();
      return /*#__PURE__*/React.createElement("div", {
        className: cls
      }, /*#__PURE__*/React.createElement(DragDropContext, {
        onDragEnd: this.onDragEnd,
        onDragStart: this.onDragStart
      }, /*#__PURE__*/React.createElement(List, {
        titleText: titles[0] //左侧标题
        ,
        dataSource: leftDataSource //左侧数据源
        ,
        filter: leftFilter //搜索框中输入的内容
        ,
        filterOption: filterOption //搜索过滤方法 参数(inputValue, option)
        ,
        style: listStyle //自定义的columns的样式表
        ,
        checkedKeys: sourceSelectedKeys //左侧已勾选的item的keys
        ,
        handleFilter: this.handleLeftFilter //左侧搜索框值更改事件
        ,
        handleClear: this.handleLeftClear //清空左侧搜索框内容
        ,
        handleSelect: this.handleLeftSelect //点击左侧列表中的item，改变选中或取消选中状态
        ,
        handleSelectAll: this.handleLeftSelectAll //点击左侧全选
        ,
        render: render,
        showSearch: showSearch //是否显示搜索框
        ,
        searchPlaceholder: searchPlaceholder //搜索框placeholder
        ,
        notFoundContent: notFoundContent //当没有相关内容的显示内容
        ,
        body: body,
        footer: footer,
        prefixCls: "".concat(clsPrefix, "-list"),
        lazy: lazy,
        showCheckbox: showCheckbox,
        draggable: draggable,
        id: '1',
        droppableId: droppableId,
        draggingItemId: draggingItemId
      }), !draggable ? /*#__PURE__*/React.createElement(Operation, {
        rightActive: rightActive,
        rightArrowText: operations[0],
        moveToRight: this.moveToRight,
        leftActive: leftActive,
        leftArrowText: operations[1],
        moveToLeft: this.moveToLeft,
        allMoveToLeft: noop,
        allMoveToRight: noop // TODO: 这两个API在改功能的时候可以补上
        ,
        className: "".concat(clsPrefix, "-operation"),
        renderOperation: renderOperation
      }) : '', /*#__PURE__*/React.createElement(List, {
        titleText: titles[1] //右侧标题
        ,
        dataSource: rightDataSource //右侧数据源
        ,
        filter: rightFilter //搜索框中输入的内容
        ,
        filterOption: filterOption //搜索过滤方法 参数(inputValue, option)
        ,
        style: listStyle //自定义的columns的样式表
        ,
        checkedKeys: targetSelectedKeys //右侧已勾选的item的keys
        ,
        handleFilter: this.handleRightFilter //右侧搜索框值更改事件
        ,
        handleClear: this.handleRightClear //清空右侧搜索框内容
        ,
        handleSelect: this.handleRightSelect //点击右侧列表中的item，改变选中或取消选中状态
        ,
        handleSelectAll: this.handleRightSelectAll //点击右侧全选
        ,
        render: render,
        showSearch: showSearch //是否显示搜索框
        ,
        searchPlaceholder: searchPlaceholder //搜索框placeholder
        ,
        notFoundContent: notFoundContent //当没有相关内容的显示内容
        ,
        body: body,
        footer: footer,
        prefixCls: "".concat(clsPrefix, "-list"),
        lazy: lazy,
        showCheckbox: showCheckbox,
        draggable: draggable,
        id: '2'
      })));
    }
  }]);

  return Transfer;
}(React.Component)) || _class);
Transfer.List = Transfer.List;
Transfer.Operation = Transfer.Operation;
Transfer.Search = Transfer.Search;
Transfer.propTypes = propTypes;
export default Transfer;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-transfer/src/Transfer.js